import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=75c5d5fc&scoped=true"
import script from "./balance.vue?vue&type=script&lang=js"
export * from "./balance.vue?vue&type=script&lang=js"
import style0 from "./balance.vue?vue&type=style&index=0&id=75c5d5fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c5d5fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c5d5fc')) {
      api.createRecord('75c5d5fc', component.options)
    } else {
      api.reload('75c5d5fc', component.options)
    }
    module.hot.accept("./balance.vue?vue&type=template&id=75c5d5fc&scoped=true", function () {
      api.rerender('75c5d5fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serve/balance.vue"
export default component.exports